import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';
import moment from 'moment';

import { Modal, message, Progress, Popover, Tag } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function () {

    }
}

const params = {
    domain: {}
};

const headers = utils.columns([
    { key: '$index', label: '序号', width: 45 },
    { key: 'classTime', label: '开课时间', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'orgName', label: '开课学院', width: 150 },
    { key: 'courseName', label: '课程名称', width: 150 },
    { key: 'employeeCode', label: '教师工号', width: 100 },
    { key: 'employeeName', label: '教师', width: 100 },
    { key: 'lessonNum', label: '节次', width: 60 },
    { key: 'classesName', label: '班级', width: 120 },
    { key: 'lessonAddress', label: '上课地点', width: 150 },
    { key: 'classGrade', label: '年级', width: 120 },
    { key: 'weekName', label: '星期', width: 60 },
    {
        key: 'attendCoursePersonName', label: '听课人', width: 500,
        render: value => { value ? value.substring(1, value.length - 1) : value },
    },
    { key: 'classWeek', label: '听课周次', width: 80 },
    {
        key: 'warnState', label: '预警状态', render: (value) => {
            if (value === 1) {
                return <span style={{ textAlign: "center", display: "block" }}><Tag color="#f50" >{"预警状态"}</Tag></span>
            } else {
                return <span style={{ textAlign: "center", display: "block" }}><Tag color="#108ee9">{""}</Tag></span>
            }
        }
    },
    { key: 'deadline', label: '选课截止时间', width: 150, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    {
        key: 'listeningProgress', label: '听课进度', width: 80, render: (value) => <span>
            <Progress percent={value || 0} />
        </span>
    },
    {
        key: 'taskState', label: '任务状态', width: 80, render: (value) => {
            if (value === 1) return "进行中";
            else if (value === 2) return "已完成";
            else return "未开始";
        }
    },
    { key: 'evalTypeName', label: '测评类型', width: 60 },
]);



/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('course/plan/selection/task/get/' + id, {})
        .then(response => response.payload.data)
        .catch(error => {
        });
}



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('course/plan/selection/task/list', Object.assign(defaultsParams, keywords))
        .then(response => {
            const columns = [
                { key: '$index', label: '序号', width: 60,
                style: {
                    width: 60,
                    minWidth: 60
                } },
                { key: 'classTime', label: '开课时间', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
                { key: 'orgName', label: '开课学院', width: 150 },
                { key: 'courseName', label: '课程名称', width: 150 },
                { key: 'employeeCode', label: '教师工号', width: 100 },
                { key: 'employeeName', label: '教师', width: 100 },
                {
                    key: 'listeningProgress', label: '听课进度', width: 120, render: (value) => <span>
                        <Progress percent={value || 0} />
                    </span>
                },
                {
                    key: 'attendCoursePersonName', label: '听课人', width: 220,
                    style: {
                        width: 220,
                        minWidth: 220
                    },
                    render: value =>
                        <span>
                            <Popover style={{ width: 300 }} content={

                                <div style={{ width: 200 }}>
                                    <div>
                                        {value || ""}
                                    </div>
                                </div>}
                            >
                                {<a style={{ color: '#24619a' }} href="javascript:;">{value ? value.substring(1, value.length - 1) : value}</a>}
                            </Popover>
                        </span>
                },
                {
                    key: 'warnState', label: '预警状态', render: (value) => {
                        if (value === 1) {
                            return <span style={{ textAlign: "center", display: "block" }}><Tag color="#f50" >{"预警状态"}</Tag></span>
                        } else {
                            return <span style={{ textAlign: "center", display: "block" }}>{""}</span>
                        }
                    }
                },
                {
                    key: 'taskState', label: '任务状态', width: 80, render: (value) => {
                        if (value === 1) return "进行中";
                        else if (value === 2) return "已完成";
                        else if (value === 4) return "已过期";
                        else return "未开始";
                    }
                },
                { key: 'classGrade', label: '年级', width: 120 },
                { key: 'lessonAddress', label: '上课地点', width: 120 },
                { key: 'weekName', label: '星期', width: 60 },
                { key: 'lessonNum', label: '节次', width: 60 },
                { key: 'classesName', label: '班级', width: 120 },
                { key: 'classWeek', label: '听课周次', width: 80, render: (value) => value ? `第${value}周` : "" },
                { key: 'deadline', label: '选课截止时间', width: 150, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
                { key: 'itemName', label: '测评指标', width: 100 },
                { key: 'evalTypeName', label: '测评类型', width: 100 },
            ];
            return {
                headers: utils.columns(columns),
                data: response.payload.data,
            };
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}


/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('course/plan/selection/insert', data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '信息添加成功!',
                    content: (
                        <div>
                            <p>点击确认后，将自动跳转到管理页面！</p>
                        </div>
                    ),
                    onOk() {
                        // window.location.hash = '/plan/CoursePlanSimple/index';
                    },
                    okText: "确认",
                });
            }

        });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('course/plan/selection/update/' + id, data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '教学系统课表信息更新成功!',
                    content: (
                        <div>
                            <p>点击确认后，将自动跳转到选课发布页面！</p>
                        </div>
                    ),
                    onOk() {
                        // window.location.hash = 'course/plan/index';
                    },
                    okText: "确认",
                });
            }
        });
}

const updateTask = (data) => {
    return fetch.post('course/plan/selection/task/update', data)
        .then(response => {
            params.domain = {};
            if (response.code === 200) {
                return response.payload.data;
            }
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('course/plan/selection/task/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback, setLoading) => {
    return new Promise(function (resolve, reject) {
        if (DataGrid.selections.length === 0) {
            Modal.error({
                title: '请先选择一项或多项！',
                content: '只有勾选一项或多项后才能删除！',
            });
        } else {
            Modal.confirm({
                title: '确定删除该记录？',
                content: '删除后将无法恢复！',
                onOk() {
                    setLoading ? setLoading(true) : "";
                    remove(DataGrid.selections).then(response => {
                        if (response.code === 200) {
                            if (response.payload.data.fail === 0) {
                                message.success(response.message);
                            } else {
                                message.warn("删除操作： 成功" + response.payload.data.success + "个;失败" + response.payload.data.fail + "个\n"
                                    + "存在已测评的记录，请删除测评结果后再进行删除！"
                                )
                            }

                            resolve();
                            DataGrid.selections = [];
                            callback();
                        } else {
                            reject();
                        }
                    });
                },
                onCancel() { },
                okText: "确认",
                cancelText: "取消"
            });
        }
    })
}

/**
 * @method expprtData
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const expprtData = (data) => {
    const ids = DataGrid.selections;
    return fetch.post('course/plan/simple/publish', Object.assign({}, data, { ids }))
        .then(response => {
            params.domain = {};
            if (response.code === 200) {
                return response.payload.data.studentCourseInt;
            }
            return 0;
        });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const getSelectionData = () => {
    return DataGrid.selectData;
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
const exportList = (keywords) => {
    return fetch.download('course/plan/selection/task/export', keywords, "听课任务信息数据导出.xls")
}

const getCourseListener = (id) => {
    return fetch.post(`course/plan/selection/task/getCourseListener/${id}`, {})
}

const updateAttendCoursePerson = (id, params) => {
    return fetch.post(`course/plan/selection/task/updateAttendCoursePerson/${id}`, params)
}

/**
 * @method updateSubmitState
 * @param {number} id
 * @return {promise}
 */
const updateSubmitState = (id) => {
    return fetch.get('course/plan/selection/task/updateSubmitState/' + id, {})
        .then(response => response.payload.data)
        .catch(error => {
        });
}



const querySearchTypeTree = (id) => {
    return fetch.get('course/plan/selection/task/targetTree/' + id)
        .then(response => response.payload.data)
        .then(result => {
            const data = transform(utils.tree(result));
            const maps = codes(result);
            return {
                data,
                maps
            }
        })
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    onSelectData,
    batchRemove,
    setRefresh,
    getSelection,
    getSelectionData,
    expprtData,
    params,
    exportList,
    getCourseListener,
    updateAttendCoursePerson,
    updateSubmitState,
    querySearchTypeTree,
    updateTask
}